export const STUDIO_CATALOG_PATH = '/pnl-report-studio/catalog';
export const STUDIO_DECK_TYPES_PATH = '/pnl-report-studio/deck-types';
export const STUDIO_SCENARIOS_PATH = '/pnl-report-studio/scenarios';
export const STUDIO_TEMPLATE_PATH = '/pnl-report-studio/templates';
/** Reopen an already-saved report in the Studio. Same shape as a template, seeded with its own selections. */
export const STUDIO_REPORT_PATH = '/pnl-report-studio/reports';
export const STUDIO_DRAG_TYPE = 'application/x-stargrid-studio';
//: Carries the source column index when a scenario card is dragged to reorder columns.
export const STUDIO_COLUMN_REORDER_TYPE = 'application/x-stargrid-column-index';
/** Per-list reorder payloads, so a row card can never drop into the line set (or vice versa). */
export const STUDIO_ROW_REORDER_TYPE = 'application/x-stargrid-row-index';
export const STUDIO_LINE_REORDER_TYPE = 'application/x-stargrid-line-index';
export const STUDIO_SELECTION_KINDS = ['all', 'members', 'subset', 'children', 'descendants', 'line_set'] as const;
export const STUDIO_FORMAT_KINDS = ['number', 'currency', 'percentage', 'basisPoints'] as const;

export const PNL_DIMENSIONS_PATH = '/pnl-dimensions';
export const STUDIO_SOURCE_MODE = 'ICEBERG';
export const STUDIO_HIDDEN_CONTEXT_KEYS: readonly string[] = ['}APQ Cube View'];
export const STUDIO_NATIVE_OPTION_LIMIT = 100;

export const STUDIO_EAGER_COLUMNS = 4;
export const STUDIO_COLUMN_PRELOAD_MARGIN_PX = 300;

export const STUDIO_TEMPLATE_FAMILY_LABEL_KEYS: Readonly<Record<string, 'studioTemplateProduct' | 'studioTemplateGp' | undefined>> = {
  pnl: 'studioTemplateProduct',
  'gross-profit': 'studioTemplateGp'
};
